<template>
    <div>
        <label :for="`title_${menuIndex}`">Title</label>
        <input
            :id="`title_${menuIndex}`"
            v-model="menu.title"
            class="form-control"
            :class="{
                'is-invalid': v.title.$error
            }"
            dir="auto"
            @input="emitMenu"
        />

        <tabs
            :items="sections"
            :active-item="section"
            class="mt-4 mb-3"
            @item-change="section = $event"
        />

        <articles
            v-if="section.value === 'articles'"
            :value="menu.articles"
            @input="onInput('articles', $event)"
        />

        <sub-menus
            v-if="section.value === 'subMenus'"
            :value="menu.subMenus"
            :index="menuIndex"
            :v="v.subMenus"
            @input="onInput('subMenus', $event)"
        />

        <links
            v-if="section.value === 'links'"
            :value="menu.links"
            :v="v.links"
            @input="onInput('links', $event)"
        />
    </div>
</template>

<script>
import Links from './Links';
import SubMenus from './SubMenus';
import Articles from './Articles';
import Tabs from '@/components/elements/Tabs';

export default {
    components: {
        Links,
        SubMenus,
        Articles,
        Tabs
    },

    props: {
        value: {
            type: Object,
            required: true
        },
        v: {
            type: Object,
            required: true
        },
        menuIndex: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            menu: { ...this.value },
            section: { value: 'articles' }
        };
    },

    computed: {
        sections() {
            const sections = [
                {
                    value: 'articles',
                    text: 'Articles'
                },
                {
                    value: 'subMenus',
                    text: 'Menu Items'
                },
                {
                    value: 'links',
                    text: 'Links'
                }
            ];

            return sections.map(item => {
                return {
                    ...item,
                    isError: this.v[item.value].$error
                };
            });
        }
    },

    methods: {
        onInput(property, value) {
            this.menu[property] = [...value];

            this.emitMenu();
        },

        emitMenu() {
            this.$emit('input', this.menu);
        }
    }
};
</script>
